import Slider from "react-slick";
import { useNavigate } from "react-router-dom";
import { Row, Col } from "react-bootstrap";
import ReactHtmlParser from "react-html-parser";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import * as Assets from "./../../utils/svg_assets";
import * as PageRoutes from "../../utils/route_pages";
import ApiUtils from "./../../utils/api_utils";
import { readMore } from "../../utils/utilities";
import "./style.scss";

const CarouselSlider = ({ data, isNews = false }) => {
  const navigate = useNavigate();

  const settings = {
    arrows: false,
    infinite: false,
    speed: 300,
    variableWidth: true,
  };

  const handleNavigate = (id) => {
    let toPath = {
      pathname: `${PageRoutes.detailNews}/${id}`,
    };

    if (isNews) toPath.search = "?isNews=true";

    navigate(toPath);
  };

  const newsItem =
    data &&
    data.map((item, index) => {
      return (
        <div
          style={{ width: 260 }}
          key={index}
          onClick={() => handleNavigate(item.id)}
        >
          <div className="wrapper-img-slider shadow-sm mb-2">
            <div
              className="img-content"
              style={{
                backgroundSize: "cover",
                backgroundImage: `url(${ApiUtils.validateImgUrl({
                  url: item?.images?.img?.display,
                })}`,
              }}
            >
              <div className="description">
                <div className="text-white font-bold text-lg mb-2">
                  {item.title}
                </div>
                <div className="text-white font-medium text-sm">
                  {ReactHtmlParser(readMore(item.description))}
                </div>
              </div>
            </div>
            <Row className="p-3">
              <Col xs={1}>
                <img
                  src={Assets.iconLikeSolid}
                  alt="iconCommentSolid"
                  className="img-responsive"
                />
              </Col>
              <Col xs={3}>&nbsp; {item.total_like}</Col>
              <Col xs={1}>
                <img src={Assets.iconCommentSolid} alt="iconCommentSolid" />
              </Col>
              <Col>&nbsp; {item.total_comment}</Col>
            </Row>
          </div>
        </div>
      );
    });

  return <Slider {...settings}>{newsItem}</Slider>;
};

export default CarouselSlider;
